var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntenLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 18,
    viewBox: "0 0 59 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3244C",
    d: "M8.819.172c4.87 0 8.819 3.936 8.819 8.791s-3.949 8.792-8.82 8.792C3.949 17.755 0 13.818 0 8.963S3.948.173 8.819.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C92659",
    d: "M29.396.172c4.87 0 8.82 3.936 8.82 8.791s-3.95 8.792-8.82 8.792-8.819-3.937-8.819-8.792 3.949-8.79 8.82-8.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F02867",
    d: "M49.974.172c4.87 0 8.819 3.936 8.819 8.791s-3.949 8.792-8.82 8.792c-4.87 0-8.818-3.937-8.818-8.792s3.948-8.79 8.819-8.79"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenLogo);
export default __webpack_public_path__ + "static/media/anten-logo.215796fabff17fa2f4fcdb4b7207126e.svg";
export { ForwardRef as ReactComponent };